export default __webpack_public_path__ + "static/media/Logo.111924d6.svg";